module.exports = __webpack_public_path__ + "img/gift4-01-c01-k2.e69a41dd.png";